import React from 'react';
import PropTypes from 'prop-types';
import { Link as v4Link } from 'react-router-dom';
import cx from 'classnames';

// Constellation Components
import {
    IconCameraOutline,
    Text,
} from '@zillow/constellation';

// constants
import SelectPropertyConstants from 'app/shared/constants/SelectPropertyConstants';

// Styled Components
import {
    StyledListingStatus,
    StyledStatusMessage,
    StyledImg,
    StyledLink,
    StyledSelectPropertyCardContent,
    StyledPropertyItemStatus,
    StyledPhotoContainer,
    StyledCard,
} from '../StyledComponents';

const propTypes = {
    type: PropTypes.oneOf([
        'applications',
        'leases',
        'listings',
        'payments',
    ]).isRequired,
    listing: PropTypes.object.isRequired,
};

const defaultProps = {};

function SelectPropertyCard(props) {
    const { listing, type, className } = props;
    const {
        city,
        message,
        state,
        street,
        unit,
        zip,
        primaryPhotoUrl,
        urlPath,
    } = listing;

    const cityStateZip = `${city}, ${state} ${zip}`;
    const streetWithUnit = unit !== '' ? `${street}, ${unit}` : `${street}`;

    const renderPhoto = () => {
        const imageTag = (
            <StyledImg src={primaryPhotoUrl} alt="hero" />
        );

        const noPhoto = (
            <IconCameraOutline size="md" />
        );

        return (
            primaryPhotoUrl ? imageTag : noPhoto
        );
    };

    const renderSummary = () => {
        const statusClassName = cx(`Status-${type}`);
        switch (type) {
            case SelectPropertyConstants.LISTINGS:
                return (
                    <div className={statusClassName}>
                        <StyledListingStatus
                            marginRight="xs"
                            message={message}
                        />
                        <StyledStatusMessage>{message}</StyledStatusMessage>
                    </div>
                );

            // fall through
            case SelectPropertyConstants.APPLICATIONS:
            case SelectPropertyConstants.LEASES:
            case SelectPropertyConstants.PAYMENTS:
                return (
                    <div className={statusClassName}>{message}</div>
                );

            default:
                console.warn('No Case for: ', type);
                break;
        }
    };

    const escapeUrl = type !== SelectPropertyConstants.LISTINGS;
    const status = renderSummary();

    return (
        <StyledLink
            className={`${className} SelectPropertyCard-Anchor`}
            to={urlPath}
            escape={escapeUrl}
            reactRouterLink={v4Link}
            type="none"
        >
            <StyledCard
                mediaQuery={{ xl: { marginRight: 'md' } }}
                className="SelectPropertyCard"
                cardType="secondary"
                cardPadding={0}
            >
                <StyledPhotoContainer>
                    {renderPhoto()}
                </StyledPhotoContainer>

                <StyledSelectPropertyCardContent padding="sm">
                    {status && (
                        <StyledPropertyItemStatus
                            marginBottom="xs"
                            fontType="body"
                            as="div"
                        >
                            {status}
                        </StyledPropertyItemStatus>
                    )}

                    <div className="Property-Item-Address-Container">
                        <Text className="Property-Item-Street" fontType="smallbody" as="div">{streetWithUnit}</Text>
                        <Text className="Property-Item-City-State-Zip" fontType="smallbody" as="div">
                            {cityStateZip}
                        </Text>
                    </div>
                </StyledSelectPropertyCardContent>
            </StyledCard>
        </StyledLink>
    );
}

SelectPropertyCard.defaultProps = defaultProps;
SelectPropertyCard.propTypes = propTypes;

export { SelectPropertyCard };
export default SelectPropertyCard;
